import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LL } from 'i18n/i18n.service';
import { CsPage } from 'providers/nav-controller';
import { SettingsService } from 'services/settings.service';
import { NotificationService } from 'services/notification.service';
import { UserDb } from 'services/user-db.service';
import { DebugService } from 'services/debug.service';
import { TelemetryService } from 'services/telemetry.service';
import { NotificationSettingsPageParams } from './notification-settings-interface';

@Component({
    selector: 'page-notification-settings',
    templateUrl: 'notification-settings-page.html',
    host: { 'class': 'notification-settings' },
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationSettingsPage extends CsPage<NotificationSettingsPageParams> {
  protected LL = LL;

  constructor(
    public settings: SettingsService,
    private notificationService: NotificationService,
    private userDb: UserDb,
    private debug: DebugService,
    private telemetry: TelemetryService,
  ) {
    super();
  }

  onNotificationToggleChange(toggleName: string, enabled: boolean) {
    this.telemetry.trackEvent('notification_toggle_changed', {
      notification_type: toggleName,
      enabled,
    });
    void this.rescheduleNotificationsAsync();
  }

  private async rescheduleNotificationsAsync() {
    await this.settings.saveAsync();
    await this.notificationService.rescheduleAllAsync(
      this.userDb,
      this.settings,
      this.debug.getNowLocal(),
    );
  }

  openDeviceNotificationSettings() {
    void this.notificationService.openDeviceSettingsAsync();
  }
}
